import { render, staticRenderFns } from "./CustomerStories.vue?vue&type=template&id=0fa6658a&scoped=true&"
import script from "./CustomerStories.vue?vue&type=script&lang=js&"
export * from "./CustomerStories.vue?vue&type=script&lang=js&"
import style0 from "./CustomerStories.vue?vue&type=style&index=0&id=0fa6658a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa6658a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
